var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.12 0.453339L8 6.56001L1.88 0.453339L0 2.33334L8 10.3333L16 2.33334L14.12 0.453339Z","fill":"black","fillOpacity":"0.77"}));
}

ChevronDown.defaultProps = {"width":"16","height":"11","viewBox":"0 0 16 11","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
